import { createClient, type SupabaseClient } from '@supabase/supabase-js';
import type { Database } from './database.types';

export interface SupabasePublicConfig {
	readonly url: string;
	readonly publishableKey: string;
}

export interface SupabaseBrowserClientOptions {
	readonly accessToken?: () => Promise<string | null>;
}

export function createBrowserSupabaseClient(
	config: SupabasePublicConfig,
	options: SupabaseBrowserClientOptions = {},
): SupabaseClient<Database> {
	return createClient<Database>(config.url, config.publishableKey, {
		accessToken: options.accessToken,
		auth: {
			autoRefreshToken: true,
			detectSessionInUrl: true,
			persistSession: true,
		},
	});
}
